import React, { useEffect } from 'react'
import { connect } from '@picostate/react'
import cx from 'classnames'
import ReactCursorPosition from 'react-cursor-position'

import store from '../state/store.js'
import { Logo, SquiggleGroup } from '@/svgs.js'
import PageLink from '@/link.js'

const letters = ['M', 'e', 'n', 'u', '', 'M', 'e', 'n', 'u', '', 'M', 'e', 'n', 'u', '',]

const updateMenu = () => {
  store.hydrate({
    navOpen: !store.state.navOpen
  })()
}

const closeMenu = () => {
  setTimeout(() => {
    store.hydrate({
      navOpen: false
    })()
  }, 300)
}

const Header = connect(state => ({
  navOpen: state.navOpen,
  background: state.background,
  sticky: state.sticky
}))
  ((props) => {
    let header = React.createRef()
    let stickyHidingTimeout = false
    useEffect(() => {
      const hDom = header.current
      window.addEventListener('scroll', (e) => {
        const trigger = 200
        const doc = document.documentElement
        const top = (window.pageYOffset || doc.scrollTop) - (doc.clientTop || 0)
        if (top > trigger) {
          if (!(hDom.classList.contains('sticky'))) {
            if (stickyHidingTimeout) window.clearTimeout(stickyHidingTimeout)
            stickyHidingTimeout = null
            store.hydrate({
              sticky: true
            })()
          }
        } else {
          if (hDom.classList.contains('sticky')) {
            store.hydrate({
              sticky: false
            })()
          }
        }
      })
    })
    return (
    <header ref={header} className={cx('header fix z3 top left x py1', props.background, {
      'open': props.navOpen,
      'sticky': props.sticky
    })}>
      <div className='container--xl ma rel z5 f jcb aic px1'>
        <div className='header__brand'>
            <PageLink to='/apply' onClick={closeMenu} className='button button__plain block button__outline'>
            <span>Brand Seeking Store?</span>
          </PageLink>
        </div>
        <div className='header__logo rel z2'>
          <PageLink to='/' className='hw' onClick={closeMenu}>
            <Logo />
          </PageLink>
        </div>
        <div className='header__menu' onClick={updateMenu}>
          <div className='header__menu-wrapper'>
            {letters.map((letter, i) => (
              <div key={i} className='header__menu-letter'>{letter}</div>
            ))}
          </div>
          <div className='header__menu-globe'>
            <span className='' />
          </div>
        </div>
      </div>
      <div className='header__nav fix top left y x bcblue f jcc aic'>
        <div className='ac rel z1 header__nav-hover'>
          <ReactCursorPosition>
            <PageLink className='header__nav-link block ac x' onClick={closeMenu} to='/whats-in-store'>
              <div className='inline-block'>
                <h1 className='rel'>
                  What's In Store
                  <SquiggleGroup />
                </h1>
              </div>
            </PageLink>
          </ReactCursorPosition>
          <ReactCursorPosition>
            <PageLink className='header__nav-link block x' onClick={closeMenu} to='/about'>
              <div className='inline-block'>
                <h1 className='rel'>
                  About
                  <SquiggleGroup />
                </h1>
              </div>
            </PageLink>
          </ReactCursorPosition>
          <ReactCursorPosition>
            <PageLink className='header__nav-link block x' onClick={closeMenu} to='/locations'>
              <div className='inline-block'>
                <h1 className='rel'>
                  Locations
                  <SquiggleGroup />
                </h1>
              </div>
            </PageLink>
          </ReactCursorPosition>
          <ReactCursorPosition>
            <PageLink className='header__nav-link block x' onClick={closeMenu} to='/events'>
              <div className='inline-block'>
                <h1 className='rel'>
                  Events
                  <SquiggleGroup />
                </h1>
              </div>
            </PageLink>
          </ReactCursorPosition>
          <ReactCursorPosition>
            <PageLink className='header__nav-link block x' onClick={closeMenu} to='/membership'>
              <div className='inline-block'>
                <h1 className='rel'>
                  For Brands
                  <SquiggleGroup />
                </h1>
              </div>
            </PageLink>
          </ReactCursorPosition>
        </div>
      </div>
    </header>
  )
})

export default Header
